<ngb-alert *ngIf="!connectivity" [dismissible]="false" type="danger"><span class="text-center mx-auto">{{selectedMachine.machine_id}} is currently offline. Machine should be Online to receive remote commands.</span></ngb-alert>

<div class="row">
	<div class="col-md-6 mb-2">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
			  <mat-panel-title>
				Fetch Log file from machine
			  </mat-panel-title>
			</mat-expansion-panel-header>

			<mat-form-field>
				<mat-select [(value)]="fileType" class="mat-form-field mat-form-field-fluid">
					<mat-option *ngFor="let item of fileTypes" [value]="item.file_type">{{item.file_desc}}</mat-option>
				</mat-select>
				<mat-hint align="start">
					<strong>Filter by type</strong>
				</mat-hint>
			</mat-form-field>

			&nbsp;
			<mat-form-field>
				<input matInput [(ngModel)]="logDate" [matDatepicker]="pickerS" placeholder="Choose a date" readonly required>
				<mat-datepicker-toggle matSuffix [for]="pickerS"></mat-datepicker-toggle>
				<mat-datepicker #pickerS></mat-datepicker>
			</mat-form-field>
			&nbsp;
			<button mat-raised-button type="button" (click)="onFetchLog()" [color]="(connectivity)?'primary':'warn'">
				Send
			</button>
			<mat-error *ngIf="fetchError">{{fetchErrorMsg}}</mat-error>
		  </mat-expansion-panel>
	</div>

	<div class="col-md-6 mb-2">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
			  <mat-panel-title>
				Out Of Order
			  </mat-panel-title>
			</mat-expansion-panel-header>

			<div class="row">
				<mat-slide-toggle class="mt-2 ml-5" color="warn" [(ngModel)]="ooOrder">Enable Out Of Order</mat-slide-toggle>
				<button mat-raised-button type="button" class="ml-auto mr-5" (click)="onOOO()" [color]="(connectivity)?'primary':'warn'">
					Send
				</button>
			</div>

			<mat-error *ngIf="fetchError">{{fetchErrorMsg}}</mat-error>
		  </mat-expansion-panel>
	</div>

	<div class="col-md-6 mb-2">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
			  <mat-panel-title>
				Vouchers
			  </mat-panel-title>
			</mat-expansion-panel-header>

			<div class="row">
				<mat-slide-toggle class="mt-2 ml-5" color="primary" [(ngModel)]="vouchersEnabled">Enable vouchers</mat-slide-toggle>
				<button mat-raised-button type="button" class="ml-auto mr-5" (click)="onVouchers()" [color]="(connectivity)?'primary':'warn'">
					Send
				</button>
			</div>

			<mat-error *ngIf="fetchError">{{fetchErrorMsg}}</mat-error>
		  </mat-expansion-panel>
	</div>

	<div class="col-md-6 mb-2">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
			  <mat-panel-title>
				Reboot Machine
			  </mat-panel-title>
			</mat-expansion-panel-header>

			<div class="row">
				<button mat-raised-button type="button" (click)="onReboot()" [color]="(connectivity)?'primary':'warn'">
					Reboot
				</button>
			</div>

			<mat-error *ngIf="fetchError">{{fetchErrorMsg}}</mat-error>
		  </mat-expansion-panel>
	</div>

	<div class="col-md-6 mb-2">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
			  <mat-panel-title>
				Dispense Mode
			  </mat-panel-title>
			</mat-expansion-panel-header>

			<mat-form-field>
				<mat-label>Desired Mode</mat-label>
				<mat-select [(value)]="dispMode.desired_mode" class="mat-form-field mat-form-field-fluid">
					<mat-option [value]="'office'">Office</mat-option>
					<mat-option [value]="'retail'">Retail</mat-option>
				</mat-select>
			</mat-form-field>

			&nbsp;

			<mat-form-field>
				<mat-label>Reported Mode</mat-label>
				<input matInput type="text" [(ngModel)]="dispMode.reported_mode" readonly/>
			</mat-form-field>

			&nbsp;
			<button mat-raised-button type="button" (click)="onModeChange()" [color]="(connectivity)?'primary':'warn'">
				Send
			</button>
			<mat-error *ngIf="fetchError">{{fetchErrorMsg}}</mat-error>
		  </mat-expansion-panel>
	</div>

	<div class="col-md-6 mb-2">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
			  <mat-panel-title>
				Cup Drop
			  </mat-panel-title>
			</mat-expansion-panel-header>

			<mat-form-field>
				<mat-label>Desired Mode</mat-label>
				<mat-select [(value)]="cupDrop.desired_mode" class="mat-form-field mat-form-field-fluid">
					<mat-option [value]="'enable'">Enable</mat-option>
					<mat-option [value]="'disable'">Disable</mat-option>
				</mat-select>
			</mat-form-field>

			&nbsp;

			<mat-form-field>
				<mat-label>Reported Mode</mat-label>
				<input matInput type="text" [(ngModel)]="cupDrop.reported_mode" readonly/>
			</mat-form-field>

			&nbsp;
			<button mat-raised-button type="button" (click)="onCupDrop()" [color]="(connectivity)?'primary':'warn'">
				Send
			</button>
			<mat-error *ngIf="fetchError">{{fetchErrorMsg}}</mat-error>
		  </mat-expansion-panel>
	</div>

	<div class="col-md-6 mb-2" *ngIf="canAccessFreeMode">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
			  <mat-panel-title>
				Free Mode
			  </mat-panel-title>
			</mat-expansion-panel-header>

			<div class="row align-items-center mb-3">
				<mat-slide-toggle class="mt-2 ml-3" color="primary" [(ngModel)]="desiredFreeVendEnabled">
					Enable free mode
				</mat-slide-toggle>
			</div>

			<mat-form-field *ngIf="desiredFreeVendEnabled">
				<mat-label>Desired quota</mat-label>
				<input matInput type="number" min="1" max="200" [(ngModel)]="desiredFreeVendQuota"/>
			</mat-form-field>

			&nbsp;

			<mat-form-field>
				<mat-label>Reported</mat-label>
				<input
					matInput
					type="text"
					[value]="freeVend.reported_enabled ? 'Enabled' : 'Disabled'"
					readonly/>
			</mat-form-field>

			&nbsp;

			<mat-form-field>
				<mat-label>Reported remaining</mat-label>
				<input
					matInput
					type="text"
					[value]="freeVend.reported_remaining == null ? '—' : (freeVend.reported_remaining + ' of ' + (freeVend.reported_quota == null ? '—' : freeVend.reported_quota))"
					readonly/>
			</mat-form-field>

			<p class="mt-2 ml-1 text-muted">
				Remaining updates from free-mode drinks as they are ingested, and when the machine reports a status change.
			</p>

			&nbsp;
			<button mat-raised-button type="button" (click)="onFreeVendChange()" [color]="(connectivity)?'primary':'warn'">
				Send
			</button>
			<mat-error *ngIf="fetchError">{{fetchErrorMsg}}</mat-error>
		  </mat-expansion-panel>
	</div>

</div>

<!-- <div class="row">
	<div class="col-md-6 mb-2">
		<mat-expansion-panel>
			<mat-expansion-panel-header>
			  <mat-panel-title>
				Dispense Mode
			  </mat-panel-title>
			</mat-expansion-panel-header>

			<mat-form-field>
				<mat-label>{{ 'Email'}}</mat-label>
				<mat-label>{{ 'Email'}}</mat-label>
			</mat-form-field>

			<mat-form-field>
				<mat-select [(value)]="fileType" class="mat-form-field mat-form-field-fluid">
					<mat-option *ngFor="let item of fileTypes" [value]="item.file_type">{{item.file_desc}}</mat-option>
				</mat-select>
				<mat-hint align="start">
					<strong>Filter by type</strong>
				</mat-hint>
			</mat-form-field>

			&nbsp;
			<button mat-raised-button type="button" (click)="onFetchLog()" [color]="(connectivity)?'primary':'warn'">
				Send
			</button>
			<mat-error *ngIf="fetchError">{{fetchErrorMsg}}</mat-error>
		  </mat-expansion-panel>
	</div>
</div> -->

